import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from '../../utils/reduxUtil'
import { searchAdAccounts } from '../../api/axios/crux/account'

export const LNB_ACCOUNT_SIZE = 200

export const fetchAdAccounts = createAxiosThunk(
  'lnb/fetchAdAccounts',
  (noArgs, { getState }) => {
    const { page, search } = getState().lnb
    return searchAdAccounts(search, page)
  }
)

const initialState = {
  isExpanded: true,
  isOver: false,
  search: '',
  actives: [],
  isLoading: false,
  adAccounts: [],
  page: 0,
  totalElements: 0,
}

const getInitialState = () => ({
  ...initialState,
  isExpanded: localStorage.getItem('lnbExpanded')
    ? JSON.parse(localStorage.getItem('lnbExpanded'))
    : true,
})
const lnbSlice = createSlice({
  name: 'lnb',
  initialState: getInitialState(),
  reducers: {
    resetLnb: () => getInitialState(),
    toggleExpanded: state => {
      const value = !state.isExpanded
      if (!value) {
        state.layerVisible = false
      }
      localStorage.setItem('lnbExpanded', value)
      state.isExpanded = value
    },
    setLnbOver: (state, { payload }) => {
      if (!state.isExpanded && !payload) {
        state.layerVisible = false
      }
      state.isOver = !state.isExpanded && payload === true
    },
    setSearch: (state, { payload: search }) => {
      state.search = search
      state.page = 0
    },
    setPage: (state, { payload: page }) => {
      state.page = page
    },
    setLnbAccount: (state, { payload }) => {
      const index = state.adAccounts.findIndex(item => item.id === payload.id)
      if (index !== -1) {
        state.adAccounts[index].name = payload.name
        state.adAccounts[index].userConfig = payload.userConfig
        state.adAccounts[index].outOfBalance = payload.outOfBalance
        state.adAccounts[index].status = payload.status
        state.adAccounts[index].lastModifiedDate = payload.lastModifiedDate
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchAdAccounts.pending, state => {
      state.isLoading = true
    })
    builder.addCase(
      fetchAdAccounts.fulfilled,
      (state, { payload: { totalElements, content } }) => {
        state.totalElements = totalElements
        state.adAccounts =
          state.search.trim() === ''
            ? content
            : content.map(({ adAccount }) => adAccount)
        state.isLoading = false
      }
    )
    builder.addCase(fetchAdAccounts.rejected, state => {
      state.isLoading = false
    })
  },
})

export const {
  resetLnb,
  toggleExpanded,
  setLnbOver,
  setSearch,
  setPage,
  setLnbAccount,
} = lnbSlice.actions

export default lnbSlice.reducer
